module.exports = __webpack_public_path__ + "media/images/stitch-2b98794c486b50cdb44ff840d605d2b8.svg";